angular.module('unergie.main')
.filter('leftPad', (StringUtils) => (value, filler) => StringUtils.leftPad(value, filler))
